if (!customElements.get('usa-return-preference')) {
  customElements.define('usa-return-preference', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const reason = this.querySelector('[data-return-reason]');
      const postage = this.querySelector('[data-return-postage]');
      const details = this.querySelector('details');
      const update = () => {
        const fault = ['Faulty or damaged item', 'Incorrect item or not as described'].includes(reason.value);
        postage.required = Boolean(reason.value);
        for (const option of postage.options) {
          const kind = option.dataset.kind;
          option.disabled = Boolean(kind && ((kind === 'fault' && !fault && reason.value !== 'Other') || (kind === 'other' && fault)));
          option.hidden = option.disabled;
        }
        if (postage.selectedOptions[0]?.disabled || !reason.value) postage.value = '';
        if (reason.value) details.open = true;
      };
      reason.addEventListener('change', update);
      postage.addEventListener('invalid', () => { details.open = true; });
      update();
    }
  });
}
